import React from "react";

const Context = React.createContext();

const defaultTime = 15000;

export class BannerProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isBannerShown: false,
      message: "",
      isSuccessBanner: false,
    };

    this.timer = null;
  }

  showBanner = (message, timeInMiliseconds, isSuccessBanner) => {
    this.setState({ message: message, isSuccessBanner });
    this.timer = setTimeout(
      () =>
        this.setState({
          isBannerShown: false,
          message: "",
          isSuccessBanner: false,
        }),
      timeInMiliseconds && typeof timeInMiliseconds === "number"
        ? timeInMiliseconds
        : defaultTime
    );

    if (message && !this.state.isBannerShown) {
      this.setState({ isBannerShown: true });
    }
  };

  hideBanner = () => this.setState({ isBannerShown: false });

  render() {
    const {
      state,
      showBanner,
      hideBanner,
      props: { children },
    } = this;

    return (
      <Context.Provider value={{ ...state, showBanner, hideBanner }}>
        {children}
      </Context.Provider>
    );
  }
}

export const BannerConsumer = Context.Consumer;
